<template>
  <section
    class="title_teaser_list "
    :class="_.get(contentData, 'conf.conf[0]') == 'layout2' ? 'background' : ''"
  >
    <div class="container-2 fade-up" v-in-viewport.once>
      <h3 class="font-34">{{ _.get(taxonomyData, "[0].title") }}</h3>
      <div class="text" v-html="_.get(taxonomyData, '[0].content')"></div>
      <div class="grid">
        <template
          v-for="(item, index) in _.orderBy(filterTeams, 'title', 'asc')"
        >
          <router-link
            tag="a"
            :to="$store.getters['main/getSingleUrl'](item)"
            class="team-info fade-up"
            v-in-viewport.once
            :key="index"
          >
            <h4 class="font-21">{{ item.title }}</h4>
            <p class="organisation">
              {{ item.organisation }}
            </p>
          </router-link>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["contentData"],
  computed: {
    taxonomyData() {
      let taxonomyNumber = _.get(
        this.contentData,
        "data.list[0].team_categories"
      );
      let allTaxonomies = _.get(
        this.$store.state.main.indx,
        "terms.team_categories"
      );
      let getData = allTaxonomies.filter(
        item => item.id == _.get(taxonomyNumber, "[0]")
      );

      return getData;
    },
    filterTeams() {
      let allData = _.get(this.contentData, "data.list");
      let singleView = _.get(
        this.$store.state.main.selected_menu,
        "routeParams.singleview"
      );
      if (allData) {
        let getData = allData.filter(item => item.id != singleView);

        return getData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title_teaser_list {
  padding: 89px 0;
  &.background {
    background: var(--thirdy-tranparent);
  }
  @media (max-width: 767px) {
    padding: 55px 0;
  }
  h3 {
    margin-bottom: 34px;
    width: fit-content;
    color: var(--bonus-txt);
  }
  .text {
    margin-bottom: 55px;
    line-height: 31.5px;
    @media (max-width: 767px) {
      margin-bottom: 34px;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 55px;
    column-gap: 30px;
    @media (max-width: 1365px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      row-gap: 34px;
      column-gap: 35px;
    }
    @media (max-width: 767px) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      row-gap: 55px;
    }
    .team-info {
      h4 {
        color: var(--bonus-txt);
        text-decoration: underline;
        text-decoration-color: var(--bonus-txt);
        text-decoration-thickness: 2px;
        text-underline-offset: 6px;
        margin-bottom: 9px;
      }
      .organisation {
        color: var(--primary-txt);
      }
    }
  }
}
</style>
